import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/allowed_ai.png'
import _imports_1 from '@/assets/images/notallowed_ai.png'


const _hoisted_1 = { class: "ai-instructor-container" }
const _hoisted_2 = { class: "inner-content" }
const _hoisted_3 = {
  key: 0,
  class: "show-instructor"
}
const _hoisted_4 = { class: "image-container" }
const _hoisted_5 = { class: "mouth" }
const _hoisted_6 = { class: "eyes" }
const _hoisted_7 = { class: "hide-prompt-container" }

import {NMarquee} from 'naive-ui'
import { ref, computed, watch, onMounted, onUnmounted, nextTick } from 'vue'
enum AlarmType {
    操作=1,
    异常=2
}

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  isMouseHidden: {
    type: Boolean,
    default: false
  },
  alarmType: {
    type: [Number, String],
    default: AlarmType.操作
  },
  promptText: {
    type: String,
    default: ''
  },
  stop: {
    type: Function,
    default: () => {}
  },
  speak: {
    type: Function,
    default: () => {}
  },
  //是否常显
  isAlwaysVisible: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {

const props = __props



const showAiInstructor = ref(true)
const showPrompt = ref(false)
const showOpenAiPrompt = ref(false)
const promptText = ref('')
const isMarqueeActive = ref(false)
const promptRef = ref<HTMLDivElement | null>(null);
const promptTextRef = ref<HTMLDivElement | null>(null);
const cssAnimation = ref(false)


watch( () => props.promptText, (newVal, oldVal) => {
    promptText.value = newVal
    if(newVal){
        if(showAiInstructor.value){
            if(!showPrompt.value){
                showPrompt.value = true;
            }
            if(!cssAnimation.value){
                cssAnimation.value = true;
            }
            props.speak({
                text: newVal,
                onEnd:()=>{
                    if(!props.isAlwaysVisible || props.alarmType == AlarmType.异常){
                        showPrompt.value = false;
                    }
                    isMarqueeActive.value = false;
                    cssAnimation.value = false;  
                }
            })
        }
    }else{
        showPrompt.value = false;
        cssAnimation.value = false;
    }
    isMarqueeActive.value = false;
    checkTextOverflow();
}, { immediate: true,deep: true})


function closeAiInstructor(){
    window?.playClick()
    if(showPrompt.value){
        showPrompt.value = false;
        promptText.value = ''
        stop()
    }
    showAiInstructor.value = false;
}

function switchAiInstructor(type:string){
    window?.playClick()
    if(type == 'open'){
        showAiInstructor.value = true;
    }else{
        showAiInstructor.value = false;
        stop()
    }
    if(showPrompt.value){
        showPrompt.value = false;
        promptText.value = ''
    }
}

async function checkTextOverflow(){
   await nextTick();
   console.log('checkTextOverflow----',!promptRef.value || !promptTextRef.value || !showPrompt.value)
    if(!promptRef.value || !promptTextRef.value || !showPrompt.value){
        return;
    }
    const promptContainerW = promptRef?.value.clientWidth;
    const promptTextW = promptTextRef?.value.scrollWidth;
    console.log('checkTextOverflow----',promptTextW > promptContainerW)
    isMarqueeActive.value = promptTextW > promptContainerW;
}

function handleResize(){
    checkTextOverflow();
}




onUnmounted(() => {
    window.removeEventListener('resize', handleResize)
})

onMounted(async () => {
    window.addEventListener('resize', handleResize)
    checkTextOverflow();
})


return (_ctx: any,_cache: any) => {
  const _component_vkm_svg = _resolveComponent("vkm-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (showAiInstructor.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_vkm_svg, {
              "icon-name": "close_icon",
              class: "icon",
              onClick: closeAiInstructor,
              style: _normalizeStyle({ cursor: __props.isMouseHidden ? 'none !important' : 'pointer !important' })
            }, null, 8, ["style"]),
            _createElementVNode("div", _hoisted_4, [
              _withDirectives(_createElementVNode("div", _hoisted_5, _cache[3] || (_cache[3] = [
                _createStaticVNode("<div class=\"wave wave1\" data-v-68a74806></div><div class=\"wave wave2\" data-v-68a74806></div><div class=\"wave wave3\" data-v-68a74806></div><div class=\"wave wave4\" data-v-68a74806></div><div class=\"wave wave5\" data-v-68a74806></div>", 5)
              ]), 512), [
                [_vShow, cssAnimation.value]
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_6, null, 512), [
                [_vShow, !cssAnimation.value]
              ]),
              _cache[4] || (_cache[4] = _createElementVNode("img", {
                class: "robot-img",
                src: _imports_0,
                alt: ""
              }, null, -1))
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "hide-instructor",
            onMouseenter: _cache[0] || (_cache[0] = ()=>{showOpenAiPrompt.value = true;}),
            onMouseleave: _cache[1] || (_cache[1] = () => {showOpenAiPrompt.value = false;}),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (switchAiInstructor('open')))
          }, [
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "eyes hide-eyes" }, null, -1)),
            _cache[7] || (_cache[7] = _createElementVNode("img", {
              class: "robot-img",
              src: _imports_1,
              alt: ""
            }, null, -1)),
            _withDirectives(_createElementVNode("div", _hoisted_7, _cache[5] || (_cache[5] = [
              _createElementVNode("div", { class: "inner-container" }, [
                _createElementVNode("p", null, "点击开启辅导教员")
              ], -1)
            ]), 512), [
              [_vShow, showOpenAiPrompt.value]
            ])
          ], 32)),
      (showPrompt.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: _normalizeClass(__props.alarmType == AlarmType.操作?'prompt-container':'prompt-container danger-prompt-container')
          }, [
            _createElementVNode("div", {
              class: "prompt-inner-content",
              ref_key: "promptRef",
              ref: promptRef
            }, [
              (isMarqueeActive.value)
                ? (_openBlock(), _createBlock(_unref(NMarquee), {
                    key: 0,
                    "auto-fill": false,
                    speed: 25
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(promptText.value), 1)
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createElementBlock("p", {
                    key: 1,
                    ref_key: "promptTextRef",
                    ref: promptTextRef
                  }, _toDisplayString(promptText.value), 513))
            ], 512)
          ], 2))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})